/**

 * Logo Shotokan AAMC — BT-048 (rouge/noir/or, source client Gilles).

 * Source originale : Image de fond/logo.png (non modifiée).

 * Assets générés : scripts/prepare-logo-assets-048.py → public/

 */



export const KARATE_LOGO_BT_ID = "BT-GSD-KARATE-INTEGRATION-NOUVEAU-LOGO-SHOTOKAN-AAMC-048";



/** Logo complet — hero et pages publiques */

export const KARATE_FULL_LOGO_ASSET = "/karate-logo.png";



/** Logo compact header — recadrage optimisé */

export const KARATE_HEADER_LOGO_ASSET = "/karate-logo-header.png";



export const KARATE_FAVICON_ASSET = "/favicon.png";

export const KARATE_APPLE_TOUCH_ICON_ASSET = "/apple-touch-icon.png";



/** Titre branding global — sans Black Dragon */

export const KARATE_BRAND_TITLE = "Shotokan AAMC";



/** Taille logo header — BT-029-R2 (présence visuelle forte, header compact). */

export const KARATE_HEADER_LOGO_SIZE = 56;

export const KARATE_HEADER_LOGO_SIZE_MOBILE = 46;



/** Référence R1 — non-régression taille minimale R2 > R1. */

export const KARATE_HEADER_LOGO_SIZE_R1 = 44;



/**

 * Logo header Shotokan — BT-048 / BT-029-R2.

 * @param {object} props

 * @param {string} [props.className]

 * @param {string} [props.testId]

 */

export function KarateHeaderLogo({ className = "karate-header-brand__logo", testId = "brand-logo" }) {

  return (

    <img

      src={KARATE_HEADER_LOGO_ASSET}

      alt=""

      className={className}

      data-testid={testId}

      width={KARATE_HEADER_LOGO_SIZE}

      height={KARATE_HEADER_LOGO_SIZE}

      decoding="async"

      draggable={false}

    />

  );

}


